import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { X } from "lucide-react";

interface AttachedFeeSidepanelProps {
  isOpen: boolean;
  onClose: () => void;
  onPay: () => void;
}

const AttachedFeeSidepanel: React.FC<AttachedFeeSidepanelProps> = ({
  isOpen,
  onClose,
  onPay,
}) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto  w-[369px]">
                  <div className="flex h-full flex-col overflow-y-scroll bg-[#F3F3F3] shadow-xl">
                    <div className="px-6 pt-5 pb-3 flex items-center justify-between">
                      <Dialog.Title className="text-base font-bold text-[#495057]">
                        Attached fees
                      </Dialog.Title>
                      {/* <button
                        type="button"
                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                        onClick={onClose}
                      >
                        <span className="sr-only">Close panel</span>
                        <X className="h-6 w-6" aria-hidden="true" />
                      </button> */}
                    </div>

                    <div className="relative flex-1 px-6 pb-6 flex flex-col gap-y-6">
                      {/* Total Card */}
                      <div className="bg-white p-6 rounded-xl border border-[#E9EAEB] shadow-sm flex flex-col gap-y-1">
                        <span className="text-sm text-[#475467]">Total</span>
                        <span className="text-3xl font-bold text-[#027A48]">
                          N4,000.00
                        </span>
                      </div>

                      {/* Claimant letter A */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Claimant letter A
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Motion</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Oath</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Seal</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                      </div>

                      <div className="border-t border-dashed border-[#E9EAEB]"></div>

                      {/* Claimant letter B (Waived) */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Claimant letter B (Waived )
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Waived</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦0.00
                          </span>
                        </div>
                      </div>

                      <div className="border-t border-dashed border-[#E9EAEB]"></div>

                      {/* Claimant letter C */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Claimant letter C
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Motion</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Oath</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Seal</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                      </div>

                      <div className="border-t border-dashed border-[#E9EAEB]"></div>

                      {/* Other services */}
                      <div className="flex flex-col gap-y-3">
                        <h3 className="text-sm font-semibold text-[#344054]">
                          Other services
                        </h3>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Seal</span>
                          <span className="text-[#1A1A1A] font-medium">
                            ₦500.00
                          </span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span className="text-[#98A2B3]">Tax</span>
                          <span className="text-[#1A1A1A] font-medium">₦t</span>
                        </div>
                      </div>

                      <div className="mt-auto pt-6 flex flex-col gap-y-4">
                        <input
                          type="text"
                          placeholder="Additional message"
                          className="w-full p-3 border border-[#D0D5DD] rounded text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
                        />
                        <button
                          onClick={onPay}
                          className="w-full bg-[#00B074] text-white py-3 rounded-lg font-medium hover:bg-[#009b65] transition-colors"
                        >
                          Make payment of N4,000.00
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AttachedFeeSidepanel;
